import { useEffect, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import LobbyChat from './LobbyChat';

function ChatPortal({ targetUserId, onClose }) {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia('(max-width: 576px)').matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const mql = window.matchMedia('(max-width: 576px)');
    const handler = () => setIsMobile(mql.matches);

    if (mql.addEventListener) mql.addEventListener('change', handler);
    else mql.addListener(handler);

    handler();

    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', handler);
      else mql.removeListener(handler);
    };
  }, []);

  const containerStyle = useMemo(() => {
    if (isMobile) {
      return {
        position: 'fixed',
        top: '1rem',
        left: '1rem',
        right: '1rem',
        bottom: '1rem',
        width: 'auto',
        height: 'auto',
        zIndex: 2000,
        borderRadius: '8px',
        overflow: 'hidden',
        boxShadow: '0 4px 20px rgba(0,0,0,0.25)',
      };
    }

    return {
      position: 'fixed',
      bottom: '1rem',
      right: '1rem',
      width: '300px',
      height: '400px',
      zIndex: 1000,
      borderRadius: '8px',
      overflow: 'hidden',
      boxShadow: '0 4px 20px rgba(0,0,0,0.25)',
    };
  }, [isMobile]);

  const closeButtonStyle = useMemo(() => {
    if (isMobile) {
      return {
        position: 'absolute',
        top: '10px',
        right: '10px',
        width: '32px',
        height: '32px',
        borderRadius: '50%',
        border: 'none',
        background: 'rgba(0,0,0,0.45)',
        color: '#fff',
        cursor: 'pointer',
        zIndex: 1,
        lineHeight: '32px',
        textAlign: 'center',
        fontSize: '16px',
      };
    }

    return {
      position: 'absolute',
      top: '6px',
      right: '6px',
      width: '24px',
      height: '24px',
      borderRadius: '50%',
      border: 'none',
      background: 'rgba(0,0,0,0.4)',
      color: '#fff',
      cursor: 'pointer',
      zIndex: 1,
    };
  }, [isMobile]);

  return createPortal(
    <div style={containerStyle}>
      <LobbyChat targetUserId={targetUserId} isMobileOverlay={isMobile} />
      <button onClick={onClose} style={closeButtonStyle}>
        X
      </button>
    </div>,
    document.body
  );
}

export default ChatPortal;